import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(public authService: AuthService, public router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn !== true) {
      this.router.navigate(['sign-in']);
    }

    const groups = JSON.parse(localStorage.getItem('groups') || '[]');
    const url = next.url.length > 0 ? next.url[0].path : '';

    if (url === 'admin' && !groups.includes('admin')) {
      if (this.isParticipant(groups)) {
        this.router.navigate(['participant']);
      }
      return false;
    }

    if (url === 'participant' && !this.isParticipant(groups)) {
      if (groups.includes('admin')) {
        this.router.navigate(['admin']);
      }
      return false;
    }

    return true;
  }

  isParticipant(groups: string[]) {
    return (
      groups.includes('participant') ||
      groups.includes('participant-18') ||
      groups.includes('parent')
    );
  }
}
